import React from 'react';

const HelportMarkIcon = ({ size = 34, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="Helport"
  >
    <rect x="2" y="2" width="44" height="44" rx="10" fill="#080810" />
    <defs>
      <linearGradient id="helportMarkGrad" x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00D27F" />
        <stop offset="1" stopColor="#38BDF8" />
      </linearGradient>
    </defs>
    <path
      d="M14 12v24M14 24h20M34 12v24"
      stroke="url(#helportMarkGrad)"
      strokeWidth="4.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HELPORT_MARK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="34" height="34" role="img" aria-label="Helport"><rect x="2" y="2" width="44" height="44" rx="10" fill="#080810"/><defs><linearGradient id="helportH" x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#00D27F"/><stop offset="1" stop-color="#38BDF8"/></linearGradient></defs><path d="M14 12v24M14 24h20M34 12v24" stroke="url(#helportH)" stroke-width="4.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>`;

export const getHelportMarkFaviconDataUri = () => {
  if (typeof window !== 'undefined' && typeof window.btoa === 'function') {
    return `data:image/svg+xml;base64,${window.btoa(HELPORT_MARK_SVG)}`;
  }
  return `data:image/svg+xml,${encodeURIComponent(HELPORT_MARK_SVG)}`;
};

export default HelportMarkIcon;
